module.exports = __webpack_public_path__ + "media/bootstrap-icons/back-c3ebd22f.svg";